<div class="rating" [class.disabled]="disabled">
  <div class="container background">
    <opac-icon *ngFor="let _ of starsIterable"
               icon="star_black"
               size="1x"
    ></opac-icon>
  </div>

  <div *ngIf="!ratedByUser" class="container selected">
    <opac-icon *ngFor="let starCount of starsIterable"
               [class.active-rating]="rating > starCount - 1"
               [icon]="rating >= starCount ? 'star_black' : 'star_half'"
               size="1x"
    ></opac-icon>
  </div>

  <div class="container" (mouseout)="handleMouseOut()">
    <opac-icon *ngFor="let starCount of starsIterable"
               [class.active]="activeStars >= starCount"
               icon="star_black"
               size="1x"
               (mouseover)="handleMouseOver(starCount)"
               (click)="handleClick(starCount)"
    ></opac-icon>
  </div>
</div>
